import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ProductDetailState {
  id: string
  name: string
  capacityInKwh: string
  chargingCapacityInKw: string
  dischargingCapacityInKw: string
  batteryTechnology: string
  paragraph14aCompatible: boolean
}
const initialState: ProductDetailState = {
  id: '',
  name: '',
  capacityInKwh: '',
  chargingCapacityInKw: '',
  dischargingCapacityInKw: '',
  batteryTechnology: '',
  paragraph14aCompatible: false
}

export const productDetailSlice = createSlice({
  name: 'productdetail',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setProductDetailSlice: (
      state,
      action: PayloadAction<ProductDetailState>
    ) => {
      state.id = action.payload.id
      state.name = action.payload.name
      state.capacityInKwh = action.payload.capacityInKwh
      state.chargingCapacityInKw = action.payload.chargingCapacityInKw
      state.dischargingCapacityInKw = action.payload.dischargingCapacityInKw
      state.batteryTechnology = action.payload.batteryTechnology
      state.paragraph14aCompatible = action.payload.paragraph14aCompatible
    }
  }
})

export const { setProductDetailSlice } = productDetailSlice.actions

export default productDetailSlice.reducer
